export default "__VITE_ASSET__cr3I5fMx__"